import { BookOpen, Cable, MessageSquare, Settings, Sparkles, Workflow } from 'lucide-react';

/** The sections of the app, in sidebar order. */
const APP_NAVIGATION = Object.freeze([
  { to: '/', label: 'Assistant', icon: MessageSquare, end: true },
  { to: '/automations', label: 'Automations', icon: Workflow },
  { to: '/connections', label: 'Connections', icon: Cable },
  { to: '/skills', label: 'Skills', icon: Sparkles },
  { to: '/knowledge', label: 'Knowledge', icon: BookOpen },
  { to: '/settings', label: 'Settings', icon: Settings }
]);

export default APP_NAVIGATION;
